import React from 'react';
import { useAuthStore } from '@/stores';
import styles from './AdminBar.module.css';

interface AdminBarProps {
    show?: boolean;
}

const AdminBar: React.FC<AdminBarProps> = ({ show = true }) => {
    const isAdminLoggedInAsUser = useAuthStore(state => state.isAdminLoggedInAsUser());
    const currentAccount = useAuthStore(state => state.currentAccount());

    if (!show || !isAdminLoggedInAsUser) {
        return null;
    }

    return (
        <div className={styles.adminBar}>
            Temporarily logged in as Creator {currentAccount?.user_id && `[${currentAccount.user_id}]`}{' '}
            {currentAccount?.username && `[${currentAccount.username}]`}
        </div>
    );
};

export default AdminBar;
